import madewithlove from "../images/madewithlove.png";
import wtwr from "../images/wtwr.png";
import aroundtheus from "../images/aroundtheus.png";
import secoffee from "../images/secoffeeshop.png";
import selibrary from "../images/selibrary.png";
import jaillc from "../images/jaillc.png";

const projectList = [
  {
    title: "J.A.I LLC Website",
    url: "https://jaillctransport.com/",
    img: jaillc,
    tech: "HTML/CSS (responsive)",
    for: "Freelancing project",
  },
  {
    title: "MadewithLove",
    url: "https://github.com/MarinU-M/project-madewithlove",
    img: madewithlove,
    tech: "React, CSS",
    for: "BootCamp final project (frontend)",
  },
  {
    title: "WTWR",
    url: "https://github.com/MarinU-M/se_project_react",
    img: wtwr,
    tech: "React, CSS, Express, Node.js, MongoDB",
    for: "BootCamp fullstack project",
  },
  {
    title: "Around the US",
    url: "https://github.com/MarinU-M/se_project_aroundtheus",
    img: aroundtheus,
    tech: "HTML/CSS, JavaScript, Webpack",
    for: "BootCamp frontend project",
  },
  {
    title: "Software Engineering Coffee Shop",
    url: "https://github.com/MarinU-M/se_project_coffeeshop",
    img: secoffee,
    tech: "HTML/CSS",
    for: "BootCamp static website project",
  },
  {
    title: "Software Engineering Library",
    url: "https://github.com/MarinU-M/se_project_library",
    img: selibrary,
    tech: "HTML/CSS",
    for: "BootCamp static website project",
  },
];

export default projectList;
